export class BAPIError extends Error {
  public readonly status?: number | string;
  public readonly aborted?: boolean;
  public readonly title?: string;

  constructor(msg: string, status?: number | string, cause?: Error, aborted?: boolean) {
    super(msg, { cause });

    if (status) {
      this.status = status;
    }

    if (aborted) {
      this.aborted = aborted;
    }
  }
}

export class ApiError extends Error {
  constructor(
    message: string,
    public status?: number,
    public details?: any,
  ) {
    super(message);
    this.name = "ApiError";
  }

  /**
   * Static factory method for creating API errors
   * Usage: throw ApiError.create("Something went wrong", response?.status, error);
   */
  static create(message: string, status?: number, details?: any): ApiError {
    return new ApiError(message, status, details);
  }
}
